function l(e, f, n, h) {
  var i = -1, d = e == null ? 0 : e.length;
  for (h && d && (n = e[++i]); ++i < d; )
    n = f(n, e[i], i, e);
  return n;
}
export {
  l as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_arrayReduce.js
// module id = 1417
// module chunks = 41